import type { FortressKit } from "../kit/types";

/**
 * The Dragonlord (2,000 gems), rebuilt on fortress v2 (2026-10-19, docs/FORTRESS_V2.md). The castle is black basalt
 * split by molten seams that breathe (`glowtw*`), crimson fish-scale roofs and molten-gold fittings, a gold claw roost
 * gripping the spire dome, a dragon skull over the gate, lava falls off the front towers, molten braziers and hoards
 * (`art/hq/base_t<1-3>__dragonlord.glb`, art/fortress/skin_dragonlord.py). Its dragon is no longer coiled on the keep:
 * it is its own model (`art/hq/fortress_drake__dragonlord.glb`, art/unitkit) flying laps round the walls, and every so
 * often it swoops down over the gate breathing fire (views/fortressCompanion.ts). The reveal: the castle wakes molten
 * and the drake roars and swoops in at 2.0 s. In a level the seams spit embers (views/fortressAmbience.ts) and the
 * strike is dragonfire orange.
 */
export const DRAGONLORD: FortressKit = {
  id: "fortress.dragonlord",
  model: "dragonlord",
  idle: { kind: "embers", colour: 0xff8a2a, every: [1.2, 2.0], count: 4, radius: 0.35, node: "condgem0" },
  strike: { core: [1, 0.95, 0.8], rim: [1, 0.45, 0.12], hex: 0xff6a1a, coreHex: 0xfff0d0 },
  reveal: "drake",
  // client v2 (2026-10-20, owner: "the dragon needs work, as does its flame breath, and the flapping of the wings"): a
  // tighter loop pulled toward the gate so it stays in the default view (on screen 74 % → 89 % of a lap at the level start
  // view, tools/video/companion_closeup.mjs), a slower, heavier wingbeat that quickens on the
  // climbs and glides the descents, and a real breath of fire (views/breathStream.ts) timed to the breath clip's jaw
  companion: {
    model: "fortress_drake__dragonlord", count: 1, scale: 0.85, around: "keep",
    radius: 2.1, squash: 0.8, ahead: 0.6, height: 0.7, bob: 0.3, dip: 1.6, bank: 0.55, lap: 11,
    clips: { fly: "fly", glide: "glide", act: "breath", roar: "roar" },
    act: { every: [7, 11], seconds: 2.6, kind: "breath" },
    gait: { cruiseHz: 0.9, beats: 1, climbGain: 0.6, glideBelow: -0.25, flapAbove: -0.05, hold: 1.2, fade: 0.4 },
    // the lips from the 2026-10-20 GLB (model faces −z): the lower jaw's tip in the jaw's frame, the snout's in the head's
    breath: { open: [0.33, 0.93], rate: 0.7, ramp: 0.06, lips: { jaw: [0, -0.03, -0.24], head: [0, 0, -0.35] }, snout: 0.3,
      aim: 3.8, reach: 5, width: [0.08, 0.7] },
    trail: { perSecond: 6, life: 0.7, colour: [1, 0.5, 0.15] },
    glow: [1, 0.55, 0.2],
  },
  ambience: { kind: "lava", every: [0.6, 1.2], colour: [1, 0.48, 0.12], hex: 0xff7a20 },
};
